import { render, staticRenderFns } from "./sinfo.vue?vue&type=template&id=6d8fcfe3&scoped=true"
import script from "./sinfo.vue?vue&type=script&lang=js"
export * from "./sinfo.vue?vue&type=script&lang=js"
import style0 from "./sinfo.vue?vue&type=style&index=0&id=6d8fcfe3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@6.11.0_webpack@5.106.2_cssnano@5.1.15__xvqntxdsimviyd2bizvnt2lsdi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8fcfe3",
  null
  
)

export default component.exports